import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useRemainingBalanceMutation } from "../../../../services/cellcast.v3"
import { useLazyGetSubClientRemainingCreditQuery } from "../../../../services/cellcast.v2"
import {
  getIsDefaultRegion,
  getDefaultRegion,
  getAllUserDetails,
} from '../../../../app/pages/UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import { toast } from 'react-toastify'
import { GetSubClientShareCreditMode } from '../../../../services/cellcast.v2.types'

type WalletProps = {
  remainingCredit?: (credit: number) => void
};

const useWallet = ({ remainingCredit }: WalletProps) => {
  const credits = useSelector((state: any) => state?.userDetails?.userDetails?.data)
  const userData: any = useSelector(getAllUserDetails)
  const [isShowCredit, setIsShowCredit] = useState(true)
  const [isSetCreditLimit, setIsShareCreditLimit] = useState(false)
  const [shareCreditRemain, setShareCreditRemain] = useState({
    type: '',
    sms: '-',
    mms: '-',
  })
  const [getRemainCredit] = useRemainingBalanceMutation()
  const [getRemainCreditAu] = useLazyGetSubClientRemainingCreditQuery()
  const isDefaultRegion = useSelector(getIsDefaultRegion)
  const userRegion = useSelector(getDefaultRegion)

  useEffect(() => {
    if (userData && userData.subClientAccountId && userData.subClientAccountId !== '') {
      if (userData._id !== userData.ownerId) {
        setIsShowCredit(false)

        if (userData.subClientLimitConfig) {
          if (
            userData.subClientLimitConfig.smsLimitPerDay > 0 ||
            userData.subClientLimitConfig.mmsLimitPerDay > 0 ||
            userData.subClientLimitConfig.smsLimitPerMonth > 0 ||
            userData.subClientLimitConfig.mmsLimitPerMonth > 0
          ) {
            setIsShareCreditLimit(true)
          }
        }
      }
    }
  }, [userData])

  useEffect(() => {
    if (isSetCreditLimit === true && !isDefaultRegion) {
      getRemainCredit({
        action: 'find_balance',
        data: null,
      })
        .then((res) => {
          if ('data' in res) {
            if (res.data && res.data.data) {
              setShareCreditRemain({
                type: 'credits per day',
                sms: res.data.data.sms.toString(),
                mms: res.data.data.mms.toString(),
              })
            }
          } else if ('error' in res) {
            const errObj = res.error as any
            if (errObj.data.message) {
              toast.error(errObj.data.message)
            } else {
              toast.error(res.error)
            }
          }
        })
        .catch((err) => {
          toast.error(err.error)
        })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSetCreditLimit])

  /** Wallet Region AU */
  useEffect(() => {
    if (isSetCreditLimit === true && isDefaultRegion) {
      getRemainCreditAu(null)
        .then((res) => {
          if ('data' in res) {
            if (res.data && res.data.data) {
              setShareCreditRemain({
                type:
                  res.data.data.mode === GetSubClientShareCreditMode.Day
                    ? `credits per day`
                    : 'credits per month',
                sms: res.data.data.credit.sms.toString(),
                mms: res.data.data.credit.mms.toString(),
              })
            }
          } else if ('error' in res) {
            const errObj = res.error as any
            if (errObj.data.message) {
              toast.error(errObj.data.message)
            } else {
              toast.error(res.error)
            }
          }
        })
        .catch((err) => {
          toast.error(err.error)
        })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSetCreditLimit])

  useEffect(() => {
    if (remainingCredit) {
      if (credits && credits.credits) {
        const total = credits.credits.sms + credits.credits.mms
        if (total > 0) {
          remainingCredit(total)
        }
      } else {
        const total = (Number(shareCreditRemain.sms) || 0) + (Number(shareCreditRemain.mms) || 0)
        if (total > 0) {
          remainingCredit(total)
        }
      }
    }
  }, [credits, remainingCredit, shareCreditRemain.sms, shareCreditRemain.mms])

  return {
    isShowCredit,
    credits,
    shareCreditRemain,
    isDefaultRegion,
    userRegion,
  }
}

export default useWallet